module.exports = __webpack_public_path__ + "static/media/USEA-LOGO.5a5317f9.jpg";